import React from "react";
import ModalAlt from "../../components/modal/ModalAlt";
import BottomDrawer from "../../shared/ui/Drawer/BottomDrawer";
import SalesExecutiveDetails from "./SalesExecutiveDetails";

const SalesExecutiveWrapper = ({ showModal, setShowModal, assignee }) => {
    return (
        <React.Fragment>
            <div className="hidden md:block">
                <ModalAlt
                    isOpen={showModal}
                    backgroundColor="white"
                    contentClass={"bg-white"}
                    onClose={() => setShowModal((prev) => !prev)}
                    innerTimes={false}
                >
                    <SalesExecutiveDetails
                        assignee={assignee}
                        onClose={() => setShowModal((prev) => !prev)}
                    />
                </ModalAlt>
            </div>

            {/* @TODO => Fix drawer content. check this for ref [/hypersrot-ui/src/app/profile/sections/AddUser.js]  @habib610 Sat March 29,2025 */}
            <div className="md:hidden">
                <BottomDrawer
                    isOpen={showModal}
                    showClose={false}
                    className="max-h-screen flex flex-col"
                    contentClass="flex-grow overflow-y-auto"
                    onClick={() => setShowModal((prev) => !prev)}
                >
                    <div className="bg-white   rounded-t-2 p-2 absolute bottom-0">
                        <SalesExecutiveDetails
                            assignee={assignee}
                            onClose={() => setShowModal((prev) => !prev)}
                        />
                    </div>
                </BottomDrawer>
            </div>
        </React.Fragment>
    );
};

export default SalesExecutiveWrapper;
